/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDeactivateCommissionPlanRequest, type DeactivateCommissionPlanRequest, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/plans/{commissionPlanId}/deactivate
 */
export interface DeactivateRequestBuilder extends BaseRequestBuilder<DeactivateRequestBuilder> {
    /**
     * Takes the plan out of use without deleting it: it is still readable, still listed, and can be switched back on later. What changes is that it is no longer eligible to be selected when a statement is generated, so generating for that sales rep fails unless another active plan covers the period. Statements already generated from it keep the rates they were calculated with and are not affected, and neither is their place in the review workflow. This is the safe way to retire a plan whose rules need changing, since rules cannot be edited in place. No request body is required — the body exists only to carry an organization switch for callers who work across several organizations.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: DeactivateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Takes the plan out of use without deleting it: it is still readable, still listed, and can be switched back on later. What changes is that it is no longer eligible to be selected when a statement is generated, so generating for that sales rep fails unless another active plan covers the period. Statements already generated from it keep the rates they were calculated with and are not affected, and neither is their place in the review workflow. This is the safe way to retire a plan whose rules need changing, since rules cannot be edited in place. No request body is required — the body exists only to carry an organization switch for callers who work across several organizations.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: DeactivateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DeactivateRequestBuilderUriTemplate = "{+baseurl}/api/commissions/plans/{commissionPlanId}/deactivate";
/**
 * Metadata for all the requests in the request builder.
 */
export const DeactivateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: DeactivateRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeactivateCommissionPlanRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
